import { connect } from "react-redux";
import HubspotConfigurationView from "./HubspotConfigurationView.jsx";
import { fetchHubspotIntegration } from "src/legacy/redux/actions/integrations.jsx";
import { updateConfiguration, overridePrimaryConfiguration, deleteSecondaryConfiguration } from "src/legacy/redux/actions/integrations/hubspot.jsx";
import _ from "lodash";

const mapStateToProps = (state, ownProps) => {
  return {
    loading: _.get(state.legacyRootReducer.settings, "integrations.hubspot.config.loading"),
    integration: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration"),
    primaryIntegration: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration.primaryIntegration"),
    secondaryInstance: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration.configuration"),
    updating: _.get(state.legacyRootReducer.settings, "integrations.hubspot.changes.saving"),
    deactivating:  _.get(state.legacyRootReducer.settings, "integrations.hubspot.deactivation.deactivating"),
    error: _.get(state.legacyRootReducer.settings, "integrations.hubspot.changes.error"),
    authenticating: _.get(state.legacyRootReducer.settings , "integrations.hubspot.authentication.authenticating"),
    user: state.users.me,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    },

    overridePrimaryConfiguration: (configuration, id) => {
      return dispatch (overridePrimaryConfiguration(configuration, id));
    },

    deleteSecondaryConfiguration: (id) => {
      return dispatch(deleteSecondaryConfiguration(id));
    },

    fetchHubspotIntegration: () => {
      return dispatch(fetchHubspotIntegration());
    },
  };
};

const HubspotConfigurationPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(HubspotConfigurationView);

export default HubspotConfigurationPage;
